import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TrialPolicy } from "../../trial-policy.model";
import { ObjectHelper } from "../../../../../core/helpers/object.helper";
import { StringHelper } from "../../../../../core/helpers/string-helper";
import { AuthService } from "../../../../../core/services/auth.service";
import { Countries } from "../../../../../core/constants/countries";
import { Permissions } from "../../../../../core/constants/permissions";

@Component({
  selector: 'app-trial-policy-card',
  templateUrl: './trial-policy-card.component.html',
  styleUrl: './trial-policy-card.component.scss'
})
export class TrialPolicyCardComponent implements OnInit {
  @Output('remove') remove = new EventEmitter<string>();
  @Output('edit') edit = new EventEmitter<string>();
  @Output('clone') clone = new EventEmitter<string>();

  @Input('policy') policy: TrialPolicy;
  @Input('isLoading') isLoading = false;

  showSites = false;
  country: string;
  objectHelper = ObjectHelper;
  stringHelper = StringHelper;
  Permissions = Permissions;

  constructor(public authService: AuthService) { }

  ngOnInit(): void {
    if (!this.isLoading && this.policy) {
      this.country = Countries.all().find(c => c.code === this.policy.countryCode)?.name ?? this.country;
    }
  }

  onRemove() {
    this.remove.emit(this.policy.id);
  }

  onClone() {
    this.clone.emit(this.policy.id);
  }

  onEdit() {
    this.edit.emit(this.policy.id);
  }

  onShowInfo() {
    this.showSites = true;
  }

  onHideInfo() {
    this.showSites = false;
  }

  categoriesToString(objects: { id: string, name: string }[]): string {
    let stringArray: string[] = [];
    objects.forEach(obj => {
      stringArray.push(obj.name);
    });

    return StringHelper.join(stringArray, ', ', 'None');
  }

  formatUrl(link: string): string {
    if (!link.startsWith('http://') && !link.startsWith('https://')) {
      return 'https://' + link;
    }
    return link;
  }
}
